import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-tunnel-page',
  templateUrl: './tunnel-page.component.html',
  styleUrls: ['./tunnel-page.component.scss']
})
export class TunnelPageComponent {
  skipToContent(event: Event,id:string): void {
    event.preventDefault(); // Prevents navigation
    const mainContent = document.getElementById(id);
    if (mainContent) {
      mainContent.focus();
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
    event.returnValue = ''; // Show native browser confirmation
  }
}
